// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMicroscopeStandAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 0H16C14.2746.00626215 10.9142.682044 8.46428 2.9108 5.96936 5.18053 4.00604 8.96689 4.00604 15H6.00907C6.00907 9.43311 7.80142 6.21947 9.8133 4.3892 11.846 2.53998 14.7019 2.00662 16 2.00006V4H18V0ZM8.01209 24V19H2.00302V24H0V17H4.00604V15H6.00907V17H10.0151V24H8.01209Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5204 4L13.7708 6L10.9688 6.00045L10.9653 6.00006L10 9.88221L11.944 10.3641L12.5317 8.00045H14.0212L14.5219 12H19.5295L20.0302 8H21.4683L22.056 10.3637L24 9.88176L23.0347 5.99961L23.0312 6.00048L20.2806 6L20.531 4H13.5204ZM15.7864 6L16.2871 10H17.7642L18.265 6H15.7864Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM17.771 15.3886L19.7292 14.75V19.6456H17.771V15.3886ZM17.771 20.6246H19.7292V22.5828H17.771V20.6246Z" fill="#FDCA40"/>
  <path d="M17.7715 15.3886 19.7297 14.75V19.6456H17.7715V15.3886ZM17.7715 20.6246H19.7297V22.5828H17.7715V20.6246Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconMedMicroscopeStandAddOnWarning is a generated icon component.
 */
let IconMedMicroscopeStandAddOnWarning = IconMedMicroscopeStandAddOnWarning_1 = class IconMedMicroscopeStandAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconMedMicroscopeStandAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMicroscopeStandAddOnWarning.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedMicroscopeStandAddOnWarning = IconMedMicroscopeStandAddOnWarning_1 = __decorate([
    customElement('zui-icon-med-microscope-stand-add-on-warning')
], IconMedMicroscopeStandAddOnWarning);
export { IconMedMicroscopeStandAddOnWarning };
